import { FC } from 'react';

import { DropdownContentProps } from '../types';

import ActionList from './ActionList';
import DatePickerContent from './DatePickerContent';

const DropdownContent: FC<DropdownContentProps> = ({
  isPickerOpen,
  isActionsOpen,
  lifetimeStartTime,
  onSetDates,
  onOpenPicker,
  onActionClick,
  ...pickerProps
}) => (
  <>
    {isPickerOpen ? (
      <DatePickerContent {...pickerProps} />
    ) : isActionsOpen ? (
      <ActionList
        {...{
          onSetDates,
          onOpenPicker,
          onActionClick,
          lifetimeStartTime
        }}
      />
    ) : null}
  </>
);

export default DropdownContent;
